import { MainContent, ModernWebLayout } from "../../components/Layout";
import { useLocation } from "react-router-dom";
import GuidelineContent from "../../components/Guideline/GuidelineContent";
import GuidelineLandingPage from "./GuidelineLandingPage";
import { ModernBreadcrumb } from "../../components/Breadcrumbs";
import useScreenSize from "../../hooks/useScreenSize";
import useAppModernisation from "../../hooks/useAppModernisation";
import GuidelineUpdatesPage from "./updates/GuidelineUpdatesPage";

const generateSelfSearch = (pathname) => {
  const arraySearch = pathname.replace("/guidelines/", "").split("/");
  const [glPage, ...rest] = arraySearch;
  return { glPage, submenu: rest };
};

function isRootMenu(pathname, guidelineObj) {
  const regex = new RegExp(`^/(?:guidelines|app/nav)/${guidelineObj?.glPage}/?$`, "i");
  return regex.test(pathname);
}

function isUpdatesPage(pathname, guidelineObj) {
  const regex = new RegExp(`^/(?:guidelines|app/nav)/${guidelineObj?.glPage}/updates/?$`, "i");
  return regex.test(pathname);
}

const ModernGuidelineNav = () => {
  const { pathname, search } = useLocation();
  const guidelineObj = generateSelfSearch(pathname);
  const { isDesktop } = useScreenSize();
  const { isAppMode } = useAppModernisation();
  const rootMenuPathname = `/guidelines/${guidelineObj?.glPage}`;

  const getMainContent = () => {
    // Show updates page on desktop, tablet, and mobile (but not in PWA mode)
    if (isUpdatesPage(pathname, guidelineObj) && !isAppMode) {
      return <GuidelineUpdatesPage />;
    }

    if (isDesktop) {
      return isRootMenu(pathname, guidelineObj) ? (
        <GuidelineLandingPage />
      ) : (
        <GuidelineContent search={search} pathname={pathname} />
      );
    }

    return <GuidelineContent search={search} pathname={pathname} />;
  };

  const showSidebar = isDesktop && !isUpdatesPage(pathname, guidelineObj);

  return (
    <ModernWebLayout
      title="Guidelines - Therapeutic Guidelines"
      stickyPageSidebar={
        showSidebar ? <GuidelineContent search={search} pathname={rootMenuPathname} /> : null
      }
      showSidebar={showSidebar}
    >
      <MainContent padding="none">
        <ModernBreadcrumb />
        {getMainContent()}
      </MainContent>
    </ModernWebLayout>
  );
};

export default ModernGuidelineNav;
